// eslint-disable-next-line no-unused-vars
import { numeral } from '@fund/basic-lib';
import { hold as config } from '../config';
// 格式化'%'时不自动除100
numeral.options.scalePercentBy100 = false;

// 持仓（饼图）- 基金持仓 - 行业
export default {

  // 格式化数据
  formatData: (row) => {
    let data = [];
    // eslint-disable-next-line array-callback-return
    row.Datas.map((c) => {
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(c.ZJZBL - 0) || c.HYMC === '合计') return;
      data = data.concat([
        {
          name: c.HYMC,
          percent: c.ZJZBL - 0,
          a: '1',
        },
      ]);
    });
    if (data.length === 0) {
      data = [{
        name: '无数据',
        percent: 1,
        a: '1',
      }];
    }
    return data;
  },

  // 绘制走势图
  drawChart(data, chart) {
    const noData = data[0].name === '无数据';
    // 绘制走势图
    chart.source(data);

    chart.scale('value', {
      tickCount: 6,
    });

    chart.legend(false);
    chart.tooltip(false);

    chart.coord('polar', {
      transposed: true,
      innerRadius: 0.75,
      radius: 0.9,
    });
    chart.axis(false);

    chart.source(data, {
      percent: {
        formatter: function formatter() {
          return '';
        },
      },
    });

    chart.interval()
      .position('a*percent')
      .color('name', noData ? ['#ccc'] : config.colors)
      .adjust('stack')
      .style({
        lineWidth: 1,
        stroke: '#fff',
      })
      .animate(false);

    chart.render();
  },
};
